<template>
  <div id="content" class="center-block">
    <div class="col-md-5 col-md-offset-1 col-xs-10 col-xs-offset-1 marging-bottom-md">
      <div class="card">
        <img src="../assets/groom/meri.jpg" alt="Meri" class="img-responsive" />
        <div class="card-body">
          <h3 class="card-title">{{ $t("groom.meri.name") }}</h3>
          <p class="card-text">
            {{ $t("groom.meri.description") }}
          </p>
        </div>
      </div>
    </div>
    <div class="col-md-5 col-md-offset-1 col-xs-10 col-xs-offset-1">
      <div class="card">
        <img src="../assets/groom/irakli.jpg" alt="Avto" class="img-responsive" />
        <div class="card-body">
          <h3 class="card-title">{{ $t("groom.avto.name") }}</h3>
          <p class="card-text">
            {{ $t("groom.avto.description") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Groom',
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.marging-bottom-md {
  margin-bottom: 20px;
}

.card {
  /* Add shadows to create the "card" effect */
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
  background: white;
  padding: 0;
  border-radius: 5px; /* 5px rounded corners */
}

/* On mouse-over, add a deeper shadow */
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
}

/* Add some padding inside the card container */
.card-body {
  padding: 2px 16px;
}

/* Add rounded corners to the top left and the top right corner of the image */
img {
    border-radius: 5px 5px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Groom.vue